module.exports = __webpack_public_path__ + "static/img/33.cda7df25.png";